import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

const initialState = {};

export const VocabFlowToolbarStore = t
  .model('VocabFlowToolbarStore', {
    isEditable: t.optional(t.boolean, false),
    editId: t.maybeNull<any>(t.string),
    editMeaning: t.maybeNull<any>(t.string),
    editSpelling: t.maybeNull<any>(t.string),
    editDisplayType: t.maybeNull<any>(t.string),
  })
  .actions((self) => ({
    setIsEditable(editable) {
      self.isEditable = editable;
    },
    setEditElement(element) {
      self.editId = element.id;
      self.editMeaning = element.meaning;
      self.editSpelling = element.spelling;
      self.editDisplayType = element.displayType;
    },
    setDisplayType(value) {
      self.editDisplayType = value;
    },
  }));

export const useVocabFlowToolbarStore = () => {
  return useStore(VocabFlowToolbarStore);
};

export const withVocabFlowToolbarStore = (Component: any) => (props: any) => {
  const createStore = useCreateStore(VocabFlowToolbarStore, initialState);
  const ViewVocabIdeaFlowStoreProvider = useProvider(VocabFlowToolbarStore);

  return (
    <ViewVocabIdeaFlowStoreProvider value={createStore}>
      <Component {...props} />
    </ViewVocabIdeaFlowStoreProvider>
  );
};

